import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import "./NewQuestionForm.css";

function NewQuestionForm({
  id,
  addquestion,
  handleRemoveQuestion,
  label,
  label_english,
  description,
  description_english,
  optionSet,
  options,
  type,
  required,
  enps,
  handleChangeInputQuestion,
  handleChangeCheckbox,
  english,
  questionnaireType,
  perspectives,
  language,
  category,
  domain,
  dimension,
}) {
  const { t } = useTranslation();

  const selectLabel = (perspective) => {
    if (perspective === "boss") {
      return "Jefe";
    } else if (perspective === "auto") {
      return "Auto";
    } else if (perspective === "peers") {
      return "Homólogos";
    } else if (perspective === "subordinates") {
      return "Subordinados";
    } else if (perspective === "clients") {
      return "Clientes";
    }
  };
  let categoryOptionsArray = [];
  let domainOptionsArray = [];
  let dimensionOptionsArray = [];

  if (questionnaireType === "traumatic") {
    categoryOptionsArray = [
      { _id: "1", title: "Acontecimiento traumatico severo" },
      { _id: "2", title: "Recuerdos persistentes sobre el acontecimiento" },
      {
        _id: "3",
        title:
          "Esfuerzo por evitar circunstancias parecidas o asociadas al acontecimiento",
      },
      { _id: "4", title: "Afectacion" },
    ];
  } else if (questionnaireType === "psychosocial") {
    categoryOptionsArray = [
      { _id: "1", title: "Ambiente de trabajo" },
      { _id: "2", title: "Factores propios de la actividad" },
      { _id: "3", title: "Organizacion del tiempo de trabajo" },
      { _id: "4", title: "Liderazgo y relaciones en el trabajo" },
    ];

    domainOptionsArray = [
      { _id: "1", title: "Condiciones en el ambiente de trabajo" },
      { _id: "2", title: "Carga de trabajo" },
      { _id: "3", title: "Falta de control sobre el trabajo" },
      { _id: "4", title: "Jornada de trabajo" },
      { _id: "5", title: "Interferencia en la relacion trabajo-familia" },
      { _id: "6", title: "Liderazgo" },
      { _id: "7", title: "Relaciones en el trabajo" },
      { _id: "8", title: "Violencia" },
    ];

    dimensionOptionsArray = [
      { _id: "1", title: "Condiciones peligrosas e inseguras" },
      { _id: "2", title: "Condiciones deficientes e insalubres" },
      { _id: "3", title: "Trabajos peligrosos" },
      { _id: "4", title: "Cargas cuantitativas" },
      { _id: "5", title: "Ritmos de trabajo acelerado" },
      { _id: "6", title: "Carga mental" },
      { _id: "7", title: "Cargas psicologicas emocionales" },
      { _id: "8", title: "Cargas de alta responsabilidad" },
      { _id: "9", title: "Cargas contradictorias o incosistentes" },
      { _id: "10", title: "Falta de control y autonomia sobre el trabajo" },
      { _id: "11", title: "Limitada o nula posibilidad de desarrollo" },
      { _id: "12", title: "Limitada o inexistente capacitacion" },
      { _id: "13", title: "Jornadas de trabajo extensas" },
      { _id: "14", title: "Influencia del trabajo fuera del centro laboral" },
      { _id: "15", title: "Influencia de las responsabilidades familiares" },
      { _id: "16", title: "Escasa claridad de funciones" },
      { _id: "17", title: "Caracteristicas del liderazgo" },
      { _id: "18", title: "Relaciones sociales en el trabajo" },
      {
        _id: "19",
        title: "Deficiente relacion con los colaboradores que supervisa",
      },
      { _id: "20", title: "Violencia laboral" },
    ];
  } else if (questionnaireType === "environment") {
    categoryOptionsArray = [
      { _id: "1", title: "Ambiente de trabajo" },
      { _id: "2", title: "Factores propios de la actividad" },
      { _id: "3", title: "Organizacion del tiempo de trabajo" },
      { _id: "4", title: "Liderazgo y relaciones en el trabajo" },
      { _id: "5", title: "Entorno organizacional" },
    ];

    domainOptionsArray = [
      { _id: "1", title: "Condiciones en el ambiente de trabajo" },
      { _id: "2", title: "Carga de trabajo" },
      { _id: "3", title: "Falta de control sobre el trabajo" },
      { _id: "4", title: "Jornada de trabajo" },
      { _id: "5", title: "Interferencia en la relacion trabajo-familia" },
      { _id: "6", title: "Liderazgo" },
      { _id: "7", title: "Relaciones en el trabajo" },
      { _id: "8", title: "Violencia" },
      { _id: "9", title: "Reconocimiento del desempeno" },
      {
        _id: "10",
        title: "Insuficiente sentido de pertenencia e inestabilidad",
      },
    ];

    dimensionOptionsArray = [
      { _id: "1", title: "Condiciones peligrosas e inseguras" },
      { _id: "2", title: "Condiciones deficientes e insalubres" },
      { _id: "3", title: "Trabajos peligrosos" },
      { _id: "4", title: "Cargas cuantitativas" },
      { _id: "5", title: "Ritmos de trabajo acelerado" },
      { _id: "6", title: "Carga mental" },
      { _id: "7", title: "Cargas psicologicas emocionales" },
      { _id: "8", title: "Cargas de alta responsabilidad" },
      { _id: "9", title: "Cargas contradictorias o incosistentes" },
      { _id: "10", title: "Falta de control y autonomia sobre el trabajo" },
      { _id: "11", title: "Limitada o nula posibilidad de desarrollo" },
      { _id: "12", title: "Limitada o inexistente capacitacion" },
      { _id: "13", title: "Insuficiente participacion y manejo del cambio" },
      { _id: "14", title: "Jornadas de trabajo extensas" },
      { _id: "15", title: "Influencia del trabajo fuera del centro laboral" },
      { _id: "16", title: "Influencia de las responsabilidades familiares" },
      { _id: "17", title: "Escasa claridad de funciones" },
      { _id: "18", title: "Caracteristicas del liderazgo" },
      { _id: "19", title: "Relaciones sociales en el trabajo" },
      {
        _id: "20",
        title: "Deficiente relacion con los colaboradores que supervisa",
      },
      { _id: "21", title: "Violencia laboral" },
      { _id: "22", title: "Escasa o nula retroalimentacion del desempeno" },
      { _id: "23", title: "Escaso o nulo reconocimiento y compensacion" },
      { _id: "24", title: "Limitado sentido de pertenencia" },
      { _id: "25", title: "Inestabilidad laboral" },
    ];
  }

  return (
    <Col className="question-form mb-3">
      <Col className="new-question-form-header">
        <Row>
          <Col lg={11}>
            <h5>{language === "es" ? label : label_english}</h5>
          </Col>
          <Col lg={1} className="right">
            <FontAwesomeIcon
              icon={faTimes}
              onClick={() => handleRemoveQuestion(id)}
            />
          </Col>
        </Row>
      </Col>
      <Col className="mb-3">
        <FloatingLabel controlId="floatingTextarea2" label="Descripción">
          <Form.Control
            as="textarea"
            placeholder="Descripción"
            style={{ height: "100px" }}
            name="description"
            value={description}
            onChange={(event) => handleChangeInputQuestion(event, id)}
          />
        </FloatingLabel>
        {english ? (
          <FloatingLabel
            controlId="floatingTextarea3"
            label="Description"
            className="mt-3"
          >
            <Form.Control
              as="textarea"
              placeholder="Description"
              style={{ height: "100px" }}
              name="description_english"
              onChange={(event) => handleChangeInputQuestion(event, id)}
              value={description_english}
            />
          </FloatingLabel>
        ) : (
          <></>
        )}
      </Col>
      <Col className="mb-3">
        <FloatingLabel
          controlId="floatingSelect"
          label={language === "es" ? "Tipo de pregunta" : "Type of question"}
        >
          <Form.Select
            onChange={(event) => handleChangeInputQuestion(event, id)}
            name="type"
            value={type}
          >
            <option>
              {t("Cuestionarios.Cuestionario.Pregunta.NewForm.Tipo")}
            </option>
            <option value="open">
              {t("Cuestionarios.Cuestionario.Pregunta.NewForm.Abierta")}
            </option>
            <option value="options">
              {t("Cuestionarios.Cuestionario.Pregunta.NewForm.Opciones")}
            </option>
          </Form.Select>
        </FloatingLabel>
      </Col>
      {type === "options" ? (
        <Col className="mb-3">
          {options !== undefined ? (
            <FloatingLabel
              controlId="floatingSelect"
              label={language === "es" ? "Set de opciones" : "Option set"}
            >
              <Form.Select
                onChange={(event) => handleChangeInputQuestion(event, id)}
                name="optionSet"
                value={optionSet}
              >
                <option>
                  {t("Cuestionarios.Cuestionario.Pregunta.NewForm.Seleccionar")}
                </option>
                {options.map((item) => (
                  <option key={item._id} value={item._id}>
                    {language === "es" ? item.title : item.title_english}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          ) : (
            <></>
          )}
        </Col>
      ) : (
        <></>
      )}
      {questionnaireType === "traumatic" ? (
        <Col className="mb-3">
          <FloatingLabel
            controlId="floatingSelect"
            label={language === "es" ? "Categoria" : "Category"}
          >
            <Form.Select
              onChange={(event) => handleChangeInputQuestion(event, id)}
              name="category"
              value={category}
            >
              <option key="0" value="">
                Seleccionar categoria
              </option>
              {categoryOptionsArray.map((item) => (
                <option key={item._id} value={item.title}>
                  {language === "es" ? item.title : item.title}
                </option>
              ))}
            </Form.Select>
          </FloatingLabel>
        </Col>
      ) : questionnaireType === "psychosocial" ||
        questionnaireType === "environment" ? (
        <>
          <Col className="mb-3">
            <FloatingLabel
              controlId="floatingSelect"
              label={language === "es" ? "Categoria" : "Category"}
            >
              <Form.Select
                onChange={(event) => handleChangeInputQuestion(event, id)}
                name="category"
                value={category}
              >
                <option key="0" value="">
                  Seleccionar categoria
                </option>
                {categoryOptionsArray.map((item) => (
                  <option key={item._id} value={item.title}>
                    {language === "es" ? item.title : item.title}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </Col>
          <Col className="mb-3">
            <FloatingLabel
              controlId="floatingSelect"
              label={language === "es" ? "Dominio" : "Domain"}
            >
              <Form.Select
                onChange={(event) => handleChangeInputQuestion(event, id)}
                name="domain"
                value={domain}
              >
                <option key="0" value="">
                  Seleccionar dominio
                </option>
                {domainOptionsArray.map((item) => (
                  <option key={item._id} value={item.title}>
                    {language === "es" ? item.title : item.title}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </Col>
          <Col className="mb-3">
            <FloatingLabel
              controlId="floatingSelect"
              label={language === "es" ? "Dimension" : "Dimension"}
            >
              <Form.Select
                onChange={(event) => handleChangeInputQuestion(event, id)}
                name="dimension"
                value={dimension}
              >
                <option key="0" value="">
                  Seleccionar dimension
                </option>
                {dimensionOptionsArray.map((item) => (
                  <option key={item._id} value={item.title}>
                    {language === "es" ? item.title : item.title}
                  </option>
                ))}
              </Form.Select>
            </FloatingLabel>
          </Col>
        </>
      ) : (
        <></>
      )}
      {questionnaireType !== "pulso" ? (
        <Col className="mb-3">
          <Form.Check
            type="switch"
            id="custom-switch"
            label={language === "es" ? "Obligatoria?" : "Required?"}
            name="required"
            checked={required}
            onChange={(e) => handleChangeInputQuestion(e, id)}
          />
        </Col>
      ) : (
        <></>
      )}

      {questionnaireType === "pulso" ? (
        <Form.Check
          type="switch"
          label={language === "es" ? "eNPS?" : "eNPS?"}
          name="enps"
          checked={enps}
          onChange={(e) => handleChangeInputQuestion(e, id)}
        />
      ) : (
        <></>
      )}
      {questionnaireType === "competencies" ? (
        <Col className="mb-3">
          <Form.Label>
            {t("Cuestionarios.Cuestionario.Pregunta.NewForm.PreguntaContestar")}
          </Form.Label>
          <Form.Group
            as={Row}
            className="align-items-center mb-2"
            onChange={(event) => handleChangeCheckbox(event, id)}
          >
            <div key="inline-checkbox" className="mb-3">
              {perspectives.map((item) => (
                <Form.Check
                  inline
                  label={selectLabel(item.perspective)}
                  name={item.perspective}
                  type="checkbox"
                  id={item._id}
                  key={item._id}
                  defaultChecked={item.active}
                />
              ))}
            </div>
          </Form.Group>
        </Col>
      ) : (
        <></>
      )}
      <Col className="right">
        <Button className="info" onClick={addquestion}>
          {t("Cuestionarios.Cuestionario.Pregunta.NewForm.AgregarPregunta")}
        </Button>
      </Col>
    </Col>
  );
}

export default NewQuestionForm;
